import React from "react";
import withStyles from "react-jss";
import { PlanB2B } from "ComponentsUI/PlanB2B";

const styles = (theme) => ({
	root: {
		width: "100%",
		marginBottom: "20px",
		"&:last-child": {
			marginBottom: 0,
		},
	},
	headersWrapper: {
		display: "flex",
		alignItems: "center",
	},
	header: {
		fontFamily: theme.fonts.bold,
		fontSize: "18px",
		lineHeight: 2,
		letterSpacing: "2px",
		color: theme.palette.colors.darkSlateBlue,
		position: "relative",
		textTransform: "uppercase",
		marginRight: "128px",
		"&:after": {
			content: "''",
			position: "absolute",
			height: "2px",
			width: "79px",
			bottom: "-9px",
			left: 0,
			backgroundColor: theme.palette.colors.purplishBlue,
		},
		"&:first-child": {
			marginRight: "auto",
			marginLeft: "31px",
		},
	},
	list: {
		marginRight: "-20px",
		display: "flex",
		flexWrap: "wrap",
		marginTop: "60px",
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		list: {
			marginRight: "-20px",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		headersWrapper: {
			display: "flex",
			alignItems: "center",
		},
		header: {
			fontSize: "16px",
			letterSpacing: "1.8px",
			marginRight: "60px",
			"&:after": {
				width: "48px",
			},
			"&:first-child": {
				marginLeft: "20px",
			},
		},
		list: {
			marginRight: "-10px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			width: "100%",
			marginBottom: "20px",
		},
		headersWrapper: {
			display: "flex",
			flexWrap: "wrap",
			alignItems: "center",
		},
		header: {
			fontSize: "16px",
			letterSpacing: "1.8px",
			width: "100%",
			marginRight: 0,
			"&:after": {
				display: "none",
			},
			"&:first-child": {
				marginLeft: 0,
			},
		},
		list: {
			marginRight: 0,
			marginTop: "20px",
		},
	},
});

class PlansB2BBlock extends React.PureComponent {
	static defaultProps = {
		items: [],
	};
	constructor(props) {
		super(props);
	}

	generatePlans = () => {
		return this.props.items.map((item, index) => {
			return (
				<PlanB2B
					text={this.props.text}
					key={index}
					data={item}
					orderToOfficeUrl={this.props.orderToOfficeUrl}
				/>
			);
		});
	};

	render() {
		let classes = this.props.classes;
		return (
			<div className={classes.root}>
				{this.props.header && (
					<div className={classes.headersWrapper}>
						<div className={classes.header}>{this.props.header}</div>
						{this.props.header2 && <div className={classes.header}>{this.props.header2}</div>}
					</div>
				)}
				<div className={classes.list}>{this.generatePlans()}</div>
			</div>
		);
	}
}

export default withStyles(styles)(PlansB2BBlock);
